export default __webpack_public_path__ + "static/media/Delete.5ddb6719.svg";